<script setup lang="ts">
const store = useSongStore();
const { t } = useI18n();

const props = defineProps<{
  value: string;
  id: string;
  busyBg?: boolean;
}>();

const emits = defineEmits<{
  (e: "click"): void;
}>();

const showCopyButton = (() => !!navigator?.clipboard?.writeText)();
const tooltipText = ref(t("SV.LIT_ClickToCopy"));

async function onClick() {
  await store.copyToClipboard(props.value);
  tooltipText.value = t("SV.LIT_CopiedToClipboard");
  emits("click");
}

emitter.on("languageUpdated", resetTooltip);
function resetTooltip() {
  tooltipText.value = t("SV.LIT_ClickToCopy");
}
</script>

<template>
  <Tooltip
    :text="tooltipText"
    class="inline"
  >
    <button
      v-if="showCopyButton"
      :id="id"
      class="copy-btn"
      :class="{ 'busy-bg': busyBg }"
      @click="onClick"
      @mouseleave="resetTooltip"
    >
      <FAIcon class="fa-light fa-copy" />
    </button>
  </Tooltip>
</template>

<style scoped lang="postcss">
button.copy-btn {
  @apply rounded-full p-2 text-primary opacity-50 transition-all;
}
button.active,
button:hover,
button:focus-visible {
  @apply opacity-100;
}

.busy-bg {
  @apply mx-2 inline-flex aspect-square h-8 w-8 items-center justify-center rounded-full bg-white/25 align-middle text-white opacity-100;
}
</style>
